import type { FullParcel, ZarzDzaniePaczkamiService } from '@coig/apm-api';
import { getItemsList, setItem, updateItem } from './storage';

const fullParcels: FullParcel[] = [{
  id: 'P1-2f9d8197-cd47',
  sender: {
    name: 'Jan',
    surname: 'Kowalski',
    phoneNumber: '123555999',
    email: 'jkowalski@gmail.com',
    city: 'Gliwice',
    zipCode: '44-100',
    street: 'Berbeckiego'
  },
  receiver: {
    'name': 'Jan',
    'surname': 'Kowalski',
    'phoneNumber': '123555999',
    'email': 'jkowalski@gmail.com',
    'city': 'Gliwice',
    'zipCode': '44-100',
    'street': 'Berbeckiego'
  },
  parcelName: 'Przesyłka demo 1',
  status: 'READY_TO_RECEIVE',
  size: 'SMALL',
  parcelDeposited: true,
  registrationTime: '2021-08-23T09:27:19.983Z',
  statusModificationTime: '2021-08-23T09:27:19.983Z',
  compartmentId: 1
},
{
  id: 'P2-702135d3-3d68',
  sender: {
    name: 'Jan',
    surname: 'Kowalski',
    phoneNumber: '123555999',
    email: 'jkowalski@gmail.com',
    city: 'Gliwice',
    zipCode: '44-100',
    street: 'Berbeckiego'
  },
  receiver: {
    'name': 'Jan',
    'surname': 'Kowalski',
    'phoneNumber': '123555999',
    'email': 'jkowalski@gmail.com',
    'city': 'Gliwice',
    'zipCode': '44-100',
    'street': 'Berbeckiego'
  },
  parcelName: 'Przesyłka demo 2',
  status: 'READY_TO_SEND',
  size: 'MEDIUM',
  parcelDeposited: true,
  registrationTime: '2021-09-05T09:27:19.983Z',
  statusModificationTime: '2021-09-05T09:27:19.983Z',
  compartmentId: 2
},
{
  id: 'P3-f4f42ffb-5250',
  sender: {
    name: 'Jan',
    surname: 'Kowalski',
    phoneNumber: '123555999',
    email: 'jkowalski@gmail.com',
    city: 'Gliwice',
    zipCode: '44-100',
    street: 'Berbeckiego'
  },
  receiver: {
    'name': 'Jan',
    'surname': 'Kowalski',
    'phoneNumber': '123555999',
    'email': 'jkowalski@gmail.com',
    'city': 'Gliwice',
    'zipCode': '44-100',
    'street': 'Berbeckiego'
  },
  parcelName: 'Przesyłka demo 3',
  status: 'RECEIVED',
  size: 'MEDIUM',
  parcelDeposited: true,
  registrationTime: '2021-09-11T09:27:19.983Z',
  statusModificationTime: '2021-09-18T09:27:19.983Z',
  compartmentId: 3
},
{
  id: 'P4-a831a8e1-38d0',
  sender: {
    name: 'Jan',
    surname: 'Kowalski',
    phoneNumber: '123555999',
    email: 'jkowalski@gmail.com',
    city: 'Gliwice',
    zipCode: '44-100',
    street: 'Berbeckiego'
  },
  receiver: {
    'name': 'Jan',
    'surname': 'Kowalski',
    'phoneNumber': '123555999',
    'email': 'jkowalski@gmail.com',
    'city': 'Gliwice',
    'zipCode': '44-100',
    'street': 'Berbeckiego'
  },
  parcelName: 'Przesyłka demo 4',
  status: 'RECEIVED',
  size: 'LARGE',
  parcelDeposited: true,
  registrationTime: '2021-09-12T09:27:19.983Z',
  statusModificationTime: '2021-09-12T09:27:19.983Z',
  compartmentId: 4
},
{
  id: 'P5-5b882ce6-d3a2',
  sender: {
    name: 'Jan',
    surname: 'Kowalski',
    phoneNumber: '123555999',
    email: 'jkowalski@gmail.com',
    city: 'Gliwice',
    zipCode: '44-100',
    street: 'Berbeckiego'
  },
  receiver: {
    'name': 'Jan',
    'surname': 'Kowalski',
    'phoneNumber': '123555999',
    'email': 'jkowalski@gmail.com',
    'city': 'Gliwice',
    'zipCode': '44-100',
    'street': 'Berbeckiego'
  },
  parcelName: 'Przesyłka demo 5',
  status: 'SENT',
  size: 'HUGE',
  parcelDeposited: true,
  registrationTime: '2021-09-21T09:27:19.983Z',
  statusModificationTime: '2021-09-21T09:27:19.983Z',
  compartmentId: 5
},
];

export class PackageManagementMockService implements ZarzDzaniePaczkamiService {

  static mockService() {
    return true;
  }

  static async getParcelList(): Promise<{ parcels?: FullParcel[] }> {
    let parcels = getItemsList<FullParcel>('Packages');
    if (!parcels) {
      fullParcels.forEach((element: FullParcel) => setItem<FullParcel>('Packages', element));
      parcels = getItemsList<FullParcel>('Packages');
    }
    return { parcels };
  }

  static async deleteParcels() {
    updateItem('Packages', () => true, { status: 'READY_TO_RECEIVE' });
    return {
      statusCode: 0,
      statusText: 'OK',
    };
  }

  static async updateParcel(parcel: { id: string, requestBody: FullParcel }) {
    const fullParcel: FullParcel = {
      ...parcel.requestBody,
      registrationTime: parcel.requestBody.registrationTime ?? new Date().toISOString(),
      statusModificationTime: new Date().toISOString(),
    };
    updateItem('Packages', (fullParcel) => {
      return fullParcel.id === parcel.id;
    }, fullParcel);
    return fullParcel;
  }

}
